import * as React from "react";
import CryptoJS from "crypto-js";
import Divider from "@mui/material/Divider";
import Grid from "@mui/material/Grid";
import List from "@mui/material/List";
import ListItem from "@mui/material/ListItem";
import ListItemText from "@mui/material/ListItemText";
import Stack from "@mui/material/Stack";
import Typography from "@mui/material/Typography";
import { useAuth } from "../../../Auth/AuthProtecter";


const LST = process.env.REACT_APP_API_FRRS_LSTOREGE;
const secretKey = process.env.REACT_APP_SECRET_KEY_LOCALSTORAGE;

export default function Review() {
  const auth = useAuth();
  const bytes = CryptoJS.AES.decrypt(sessionStorage.getItem(LST), secretKey);
  const { stat, sucur, fech, hr, amount } = JSON.parse(
    bytes.toString(CryptoJS.enc.Utf8)
  );

  console.log(JSON.parse(bytes.toString(CryptoJS.enc.Utf8)));

  const { email, person, phone } = auth.infoUserDasboard;

  const payments = [
    { name: "Estado:", detail: stat.name },
    { name: "Sucursal:", detail: sucur.name },
    { name: "Fecha:", detail: fech.fecha },
    { name: "Hora:", detail: hr.hora },
    { name: "Maximo para compra:", detail: "$100" },
  ];

  return (
    <Stack spacing={2}>
      <List disablePadding>
        <ListItem sx={{ py: 1, px: 0 }}>
          <ListItemText primary="Producto" secondary="Compra de dólares" />
          {/* <Typography variant="body2"> ${amount.amount} </Typography> */}
        </ListItem>
        <ListItem sx={{ py: 1, px: 0 }}>
          <ListItemText primary="Total máximo a comprar:" />
          <Typography variant="subtitle1" sx={{ fontWeight: 700 }}>
            ${amount.amount}
          </Typography>
        </ListItem>
      </List>
      <Divider />
      <Stack
        direction="column"
        divider={<Divider flexItem />}
        spacing={2}
        sx={{ my: 2 }}
      >
        <div>
          <Typography variant="subtitle2" gutterBottom>
            Detalle de cita:
          </Typography>
          <Typography gutterBottom>
            Sr (a), {person.firstname} {person.lastname}
          </Typography>
          <Typography gutterBottom sx={{ color: "text.secondary" }}>
            {phone.areacode} - {phone.number}
          </Typography>
          <Typography gutterBottom sx={{ color: "text.secondary" }}>
            {email.email}
          </Typography>
        </div>
        <div>
          <Typography variant="subtitle2" gutterBottom>
            Dirección de compra:
          </Typography>
          <Grid container>
            {payments.map((payment) => (
              <React.Fragment key={payment.name}>
                <Stack
                  direction="row"
                  spacing={1}
                  useFlexGap
                  sx={{ width: "100%", mb: 1 }}
                >
                  <Typography variant="body1" sx={{ color: "text.secondary" }}>
                    {payment.name}
                  </Typography>
                  <Typography variant="body2">{payment.detail}</Typography>
                </Stack>
              </React.Fragment>
            ))}
          </Grid>
        </div>
        <Typography variant="caption" gutterBottom sx={{ display: "block" }}>
          Esto no es una factura, solo es una validación de su solicitud de
          comprar en la sucursal que seleccionó.
        </Typography>
      </Stack>
    </Stack>
  );
}
